<input
  class="numeric-input"
  type="number"
  [min]="min"
  [max]="max"
  [attr.id]="controlId"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [class.form-error-border]="error"
  (input)="handleInput($event)" />
